// eslint-disable-next-line import/prefer-default-export
export function maskSensitiveData(text: string): string {
  return text
    .replace(/(session_id)=.*/, "$1=***********")
    .replace(/(resetToken)=[\w|-]+/, "$1=***********");
}
